import moment from 'moment';

export const formateDateAll = (time) => {
  if(time || time == 0){
    return moment(time).format("YYYY-MM-DD HH:mm:ss")
  }
  return time
};
// 司机是否需要操作APP
export const sjsfxyczFormat = (type) => {
  switch(type) {
    case 1:
    case '1':
      return '是'
      break;
    case 2:
    case '2':
      return '否'
      break;
    default:
      return type
  }
};
// 提送货类型
export const tshlxFormat = (type) => {
  switch(type) {
    case 1:
    case '1':
      return '提货单'
      break;
    case 2:
    case '2':
      return '送货单'
      break;
    default:
      return type
  }
};